import { Page } from '@/core/architecture'

import { StoreItemPurchaseConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreItem Page
 * Implemented as a practical sample.
 */
export const StoreItemPurchaseConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreItemPurchaseConfirmationTemplate state={state} {...actions} />
}
